import React from 'react'
import styles from '../Components/EducationEachWrapper.module.css'

const EducationEachWrapper = props => {
    const { item } = props

    const shortenClassName = (k) => {
        if(k==="Graduation") {
            return "UG"
        } else if (k==="4th Year Graduation") {
            return "UG"
        } else {
            return k
        }
    }


    return (
        <div className={styles.mainWrapper}>
            <div className={styles.leftCol}>
                <div className={styles.className}>
                    {shortenClassName(item?.class)}
                </div>
            </div>
            <div className={styles.rightCol}>
                <div className={styles.academyTitle}>{item?.college_name}</div>
                <div className={styles.academyAddress}>{item?.college_address}</div>
                <div className={styles.year}>{item?.passing_year}</div>
            </div>
        </div>
    )
}

export default EducationEachWrapper